import { render } from "./TodaysEvent.vue?vue&type=template&id=722bb874&ts=true"
import script from "./TodaysEvent.vue?vue&type=script&lang=ts"
export * from "./TodaysEvent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__